import { useFieldState, Radio as Radio$1 } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import themes from '../../theming/themes.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import RadioLabel from './_RadioLabel.js';
import RadioText from './_RadioText.js';
import RadioButton from './_RadioButton.js';

var _excluded = ["ariaHiddenLabel", "hideLabel", "label", "theme", "containerStyle", "labelStyle", "name", "disabled", "tabIndex", "type"];
var _templateObject;
var StyledRadioButton = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: 0.5px solid lightgrey;\n    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n    color: ", ";\n    margin-left: 0;\n    &:focus {\n      outline: none;\n    }\n"])), function (_ref) {
  var _theme$palette;
  var theme = _ref.theme;
  return theme === null || theme === void 0 || (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.grayDarker;
});
var Radio = function Radio(_ref2) {
  var _ref2$ariaHiddenLabel = _ref2.ariaHiddenLabel,
    ariaHiddenLabel = _ref2$ariaHiddenLabel === void 0 ? false : _ref2$ariaHiddenLabel,
    hideLabel = _ref2.hideLabel,
    label = _ref2.label,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    containerStyle = _ref2.containerStyle,
    labelStyle = _ref2.labelStyle,
    name = _ref2.name,
    disabled = _ref2.disabled,
    _ref2$tabIndex = _ref2.tabIndex,
    tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex,
    type = _ref2.type,
    rest = _objectWithoutProperties(_ref2, _excluded);
  // FIXME: errors about field not existing when first initializing -- doesn't break but messy logs
  // TODO: could clean up so you can use Radio without Informed
  var fieldState = useFieldState(name);
  return /*#__PURE__*/React.createElement(RadioLabel, {
    hideLabel: hideLabel,
    style: containerStyle,
    error: fieldState.error,
    theme: theme,
    disabled: disabled,
    type: type
  }, /*#__PURE__*/React.createElement(Radio$1, _extends({
    tabIndex: tabIndex,
    type: "radio",
    name: name,
    disabled: disabled
  }, rest)), type !== 'button' && /*#__PURE__*/React.createElement(RadioButton, {
    theme: theme,
    error: !!fieldState.error
  }), /*#__PURE__*/React.createElement(RadioText, {
    "aria-hidden": ariaHiddenLabel,
    style: labelStyle,
    disabled: disabled,
    className: "".concat(type === 'button' && 'ml-0 mb-2 d-block')
  }, type === 'button' ? /*#__PURE__*/React.createElement(StyledRadioButton, {
    role: "button",
    className: 'p-3'
  }, label) : label));
};
var _Radio = withDefaultTheme(Radio);

export default _Radio;
